import { render } from "./LabResultTrend.vue?vue&type=template&id=bd1d3480"
import script from "./LabResultTrend.js?vue&type=script&lang=js"
export * from "./LabResultTrend.js?vue&type=script&lang=js"

import "./LabResultTrend.vue?vue&type=style&index=0&id=bd1d3480&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__